import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
  getCurrentInstance,
  inject,
  onBeforeMount,
  onUnmounted,
} from 'vue';
import { MLink } from '../index';
import { childItemsInjectionKey, parentInjectionKey } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'MBreadcrumbItemV2',
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const parentBreadcrumb = inject(parentInjectionKey);

const currentInstance = getCurrentInstance()!;
const otherItems = inject(childItemsInjectionKey)!;
onBeforeMount(() => otherItems.value.push(currentInstance));
onUnmounted(() => {
  const myIndex = otherItems.value.findIndex(
    (it) => it.uid === currentInstance.uid,
  );
  otherItems.value.splice(myIndex, 1);
});

const last = computed(
  () =>
    otherItems.value[otherItems.value.length - 1].uid === currentInstance.uid,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      'mc-breadcrumb__item',
      { 'is-active': _unref(parentBreadcrumb)?.props.responsive && last.value },
    ])
  }, [
    (!last.value)
      ? (_openBlock(), _createBlock(_unref(MLink), {
          key: 0,
          theme: _unref(parentBreadcrumb)?.props.dark ? 'light' : undefined,
          size: "s",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["theme"]))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass([
        'mc-link',
        'mc-link--s',
        'mc-breadcrumb__current',
        { 'mc-link--light': _unref(parentBreadcrumb)?.props.dark },
      ]),
          "aria-current": "page"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
  ], 2))
}
}

})